import { yup, expandScientificNotation, parseFormattedNumber } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

export const validationSchema = (t) => yup.object().shape({
    taskType: yup.string().required(t(I18N_NAMESPACE, "forms.roadworkTaskForm.taskTypeRequired")),
    quantity: decimal9_2(t),
    unit: yup.string(),
    cost: decimal9_2(t),
    comment: yup.string().nullable(),
})


const decimal9_2 = (t) => yup
    .string()
    .test(
        "decimal-11-2",
        t(I18N_NAMESPACE, "components.roadworkDetailsForm.error.invalidNumberFormat"),
        (value) => {
            const testedValue = parseFormattedNumber(value, Infinity)
            if (testedValue === undefined || testedValue === null || testedValue === "") {
                return true
            }

            const [integer, decimal] = expandScientificNotation(testedValue).split(".")
            if (integer?.toString()?.length > 9) {
                return false
            }

            if (decimal && decimal?.toString()?.length > 2) {
                return false
            }
            return true
        },
    )